module.exports = __webpack_public_path__ + "resources/record-icon-f29cf29e6e28ca60f1ba5777121bdf14.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/record-icon.png
// module id = 60
// module chunks = 0 51